<template>
  <div>
    <section>
      <VUEAppHeader :VisualizzaMenu="VisualizzaMenu" @onClickCambiaMenu="ClickCambiaMenu()"></VUEAppHeader>
      <section class="hbox stretch">
        <VUEAppSideMenu :Altezza="Altezza"></VUEAppSideMenu>
        <section id="content" style="display:block; display: flex; justify-content: flex-start;">          
          <section class="padder">
            <div v-if="TitoloPagina != ''" class="breadcrumb no-border no-radius b-b b-light">
              <span class="ZMTitoloContenuti">{{TitoloPagina}}</span>
            </div>
            <VUEAppContentSchedaUtente @OnClickConfermaModifiche="OnClickChildConfermaModifiche"></VUEAppContentSchedaUtente>
          </section>
          <a href="#" class="hide nav-off-screen-block" data-toggle="class:nav-off-screen, open" data-target="#nav,html"></a>
        </section>
        <aside class="bg-light lter b-l aside-md hide" id="notes">
          <div class="wrapper">Notification</div>
        </aside>
      </section>
    </section>
  </div>
</template>
  
  <script>
  import VUEAppHeader from '@/components/FrameComponentsMultiPurpose/VUEAppHeader.vue';
  import VUEAppSideMenu from '../components/FrameComponentsMultiPurpose/VUEAppSideMenu.vue';
  import VUEAppContentSchedaUtente from './ContentPages/VUEAppContentSchedaUtente.vue';
  
  export default 
  {
      name: "VUESchedaUtente",
      data() 
      {
       return {
                Altezza : document.documentElement.clientHeight,
                TitoloPagina : 'prova',
                Conferma : false,
                LasciaPagina : false,             
                VisualizzaMenu : false,              
              };
      },
      components: 
      {
         VUEAppHeader,
         VUEAppSideMenu,
         VUEAppContentSchedaUtente
      },
      methods: 
      {
        ClickCambiaMenu()
        {
          this.VisualizzaMenu = !this.VisualizzaMenu
        },
        getDimensions()
        {
            this.Altezza = document.documentElement.clientHeight;
        },
        AggiornaTipoPagina()
        {
          if (this.$route.params.pagina == 'nuovo')
            this.TitoloPagina = 'Nuovo Profilo'
          else this.TitoloPagina = 'Modifica Profilo'
        },
        OnClickChildConfermaModifiche()
        {
          this.LasciaPagina = true
        },
      },
      beforeMount()
      {
        this.AggiornaTipoPagina();
      },
      beforeUpdate()
      {
        this.AggiornaTipoPagina();
      },
      mounted() 
      {
        window.addEventListener('resize', this.getDimensions);
      },
      beforeRouteLeave(to, from, next)
      {
        if (!this.LasciaPagina)
        {
          let answer = window.confirm('Sei sicuro di voler lasciare la scheda? Le modifiche effettuate verranno perse.')
          if (answer)
            next()
          else
            next(false)
        }
        else next()
      },
      unmounted() 
      {
        window.removeEventListener('resize', this.getDimensions);
      },
  };
  </script>